"use strict";
var ng2_overlay_1 = require('./ng2-overlay');
exports.Ng2Overlay = ng2_overlay_1.Ng2Overlay;
var ng2_overlay_manager_1 = require('./ng2-overlay-manager');
exports.Ng2OverlayManager = ng2_overlay_manager_1.Ng2OverlayManager;
var ng2_overlay_directive_1 = require('./ng2-overlay.directive');
exports.Ng2OverlayDirective = ng2_overlay_directive_1.Ng2OverlayDirective;
var ng2_overlay_module_1 = require('./ng2-overlay.module');
exports.Ng2OverlayModule = ng2_overlay_module_1.Ng2OverlayModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-overlay/dist/index.js
// module id = 5
// module chunks = 0